<template>
  <div class="container-fluid mt-4">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Ödeme Türü Ekle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn
          class="mr-3"
          type="button"
          variant="danger"
          to="/Settings/PaymentTypes"
          :size="ButtonSize"
        >
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1">Ödeme Türleri</span>
        </b-btn>
      </b-col>
    </b-row>

    <form @submit.prevent="AddPaymentType">
      <b-form-group
        class="formgroup"
        :label="Enums[index]"
        v-for="(property, index) in PaymentType"
        :key="index"
      >
        <b-form-input
          type="text"
          v-model="PaymentType[index]"
          @keypress.enter.prevent="AddPaymentType"
        ></b-form-input>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Ekle</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../../Service";

export default {
  data() {
    return {
      Enums: {
        Name: "Ödeme Türü Adı",
        Sort: "Sıralama"
      },
      PaymentType: {
        Name: "",
        Sort: 0
      }
    };
  },
  computed: {
    ...mapState(["ButtonSize"])
  },
  methods: {
    async AddPaymentType() {
      await this.$store.dispatch("AddLoading", "AddPaymentType");

      await Services.Nozich.Send(
        "AddPaymentType",
        {
          PaymentType: this.PaymentType
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "AddPaymentType");

          if (Data.Status === "Success") {
            await this.$router.push("/Settings/PaymentTypes");
          }
        }
      );
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
